import React, { FC, useState } from 'react';
import { isEqual } from 'lodash';
import { SegmentSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { SegmentScopingModal } from '../SegmentScopingModal';
import { AdvancedOptionsLink } from '../AdvancedOptionsLink';

export interface AdvancedOptionsLinkProps {
  values: SegmentSettings[];
  onChange: (segment: SegmentSettings[]) => void;
  matchingUsersText: string;
  segmentScopeOptionText: string;
  withinMatchingSessionsText: string;
  testId?: string;
}

/** Link that launches modal to configure "advanced options", i.e. segment scoping rules. */
export const AdvancedSegmentOptionsLink: FC<AdvancedOptionsLinkProps> = ({
  values,
  onChange,
  matchingUsersText,
  segmentScopeOptionText,
  withinMatchingSessionsText,
  testId = 'advanced-segment-options-link',
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <AdvancedOptionsLink
      onClick={() => setModalOpen(true)}
      data-component="AdvancedSegmentOptionsLink"
      testId={testId}
    >
      <SegmentScopingModal
        onCloseSignal={() => setModalOpen(false)}
        segmentSettings={values}
        onChange={segment => {
          // Close modal before calling onChange() in case caller unmounts component in that call
          setModalOpen(false);
          // If the scopes have changed, create a new array/invalidate the reference to the
          // old array so that we will refetch the trend data
          if (!isEqual(segment, values)) {
            onChange([...segment]);
          }
        }}
        open={isModalOpen}
        matchingUsersText={matchingUsersText}
        segmentScopeOptionText={segmentScopeOptionText}
        withinMatchingSessionsText={withinMatchingSessionsText}
      />
    </AdvancedOptionsLink>
  );
};
